module.exports = {
    environment: process.env.ELEVENTY_ENV,
    name: "North Falls Offshore Wind Farm Consultation",
    url: process.env.ELEVENTY_ENV === 'dev' ? 'https://north-falls-test.netlify.app' : 'https://consultation.northfallsoffshore.com',

    base: {
        "contact_address": "",
        "contact_number": "",
        "contact_email": ""
    },

    meta: {
        "defaultSocialImage": "/assets/images/gg-wind-farm.jpg",
        "author": "North Falls Offshore Wind Farm",
        "description": "North Falls Offshore Wind Farm, an extension project to the existing 504 MW Greater Gabbard Offshore Wind Farm, is being developed in the southern North Sea more than 20km off the UK coast.",
        "gtag": "GTM-5J7QSHS",
        "gtm": "G-61X2GWQC5N"
    },

    form: {
        "feedback": {
            "recaptcha": "6LdXoMocAAAAAIKL5PQzCb5KtzcaMguQgH2VqO37",
        }
    },

    consultation: {   
        "feedback_active": true, 
        "start_datetime": "",
        "end_datetime": "",
        "closed_message": "This consultation has now closed. We will be updating this website at the start of 2022 with a summary of the feedback we received, so please keep checking back. There will also be further consultations in 2022, where we will be sharing more information about our project and giving people more opportunities to have their say.",

        themes: {
            1: {
                "name": "Need / Rationale",
                "icon": "caret"
            },
            2: {
                "name": "Development Process",
                "icon": "caret"
            },
            3: {
                "name": "Scoping",
                "icon": "caret"
            },
            4: {
                "name": "The Project: Offshore",
                "icon": "caret"
            },
            5: {
                "name": "The Project: Landfall",
                "icon": "caret"
            },
            6: {
                "name": "The Project: Onshore",
                "icon": "caret"
            }
        }
    },

    hasMap: true,

    // Ensure this URL does NOT have a trailing slash on the URL. Map reporting will fail.
    mapUrl: process.env.ELEVENTY_ENV === 'dev' ? 'https://north-falls-map.jfd-test.co.uk' : 'https://consultationmap.northfallsoffshore.com',

    // Bugsnag API Key
    bugsnagApiKey: '201c481d43ac9dab7cc0c31d03fddfe0'
};